import { isNullOrUndefined } from 'shared/lib/object/object';

export const isEmptyRange = (range) => {
  if (range.minType !== undefined && isNullOrUndefined(range.min)) {
    return true;
  }
  if (range.maxType !== undefined && isNullOrUndefined(range.max)) {
    return true;
  }
  return false;
};
